import { Avatar, Menu } from 'antd';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { colors } from '@theme/colors';
import { HSMSIcon, HSMSSiderIcon } from '@components/shared';
import { useMst } from '@models/Root';
import { apolloClient } from '@lib/apollo';
import { authProvider } from '@lib/auth';
import Router from 'next/router';
import Link from 'next/link';
import { stringToColour } from '@lib/stringToColour';

const { SubMenu } = Menu;

const HSMSTopMenuContainer = styled(Menu)`
  text-align: right;
  display: flex;
  justify-content: end;

  &.ant-menu {
    padding-right: 16px;
    color: ${colors.primaryBGColor};
  }

  .ant-badge {
    position: absolute;
    float: right;
    margin-top: 5px;
    right: 13px;
  }

  #hsms-icon {
    font-size: 22px;
    -webkit-transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .ant-badge-count {
    -webkit-transition: background-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: background-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .hsms-quick-icon {
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-menu-item,
  .ant-menu-submenu {
    border-color: transparent !important; // Forgive me for my sins! 😔💀

    &:hover .ant-badge-count {
      //background-color: ${colors.secondaryColor};
    }

    &:hover .hsms-icon {
      color: ${colors.secondaryColor};
    }
  }

  .ant-menu-item:hover,
  .ant-menu-item-active,
  .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .ant-menu-submenu-active,
  .ant-menu-submenu-title:hover {
    .hsms-icon {
      color: ${colors.secondaryColor};
    }
  }

  .ant-avatar {
    background: transparent;

    #hsms-icon {
      font-size: 27px;
      margin-left: -2px;
      margin-top: 1px;
    }
  }

  .user-name {
    margin-left: 9px;
  }
`;

export const HSMSTopMenu = observer(() => {
  const { reset, user, student } = useMst();

  return (
    <HSMSTopMenuContainer id="app-top-menu" mode="horizontal" className="quick-menu" selectable={false}>
      <SubMenu
        key="profile"
        title={
          <span className="submenu-title-wrapper">
            {user?.id && <Avatar src={user.profilePicture} icon={<HSMSIcon name="account_circle" />} />}
            {student?.id && (
              <Avatar
                style={{
                  backgroundColor: `#${stringToColour(student?.firstName || 'Student')}`,
                }}
              >
                {student?.firstName?.split('')[0].toUpperCase()}
                {student?.lastName?.split('')[0].toUpperCase()}
              </Avatar>
            )}
            <span className="user-name">
              {user.firstName || student.firstName} {user.lastName || student.lastName}
            </span>
          </span>
        }
      >
        {student.id && (
          <Menu.Item key="user:profile">
            <Link href={student.id ? `/students/${student.regNumber}` : '/'}>
              <div>
                <HSMSSiderIcon className="anticon" name="person" />
                <span>Profile</span>
              </div>
            </Link>
          </Menu.Item>
        )}
        <Menu.Item
          key="user:logout"
          onClick={async () => {
            reset();

            await apolloClient.clearStore();
            await apolloClient.cache.reset();

            await authProvider.logoutUser();

            Router.push('/login').then(() => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              window.location.reload(true);
            });
          }}
        >
          <HSMSSiderIcon className="anticon" name="exit_to_app" />
          <span>Logout</span>
        </Menu.Item>
      </SubMenu>
    </HSMSTopMenuContainer>
  );
});
